import {useMutation} from '@apollo/client';
import gql from 'graphql-tag';
import {GraphQLError} from 'graphql';
import React, {FunctionComponent} from 'react';
import Rating from '../../ui/Rating';
import Avatar from '../../ui/Avatar';
import PrimaryButton from '../../ui/PrimaryButton';
import IconRingSpinner from '../icon/IconRingSpinner';
import {showError, showInfo} from '../../ui/ToastNotification';
import OldUrls from '../../models/utils/OldUrls';
import {reverse} from "../../urls";

type EvaluationProps = {
  id: string
  rating: number
  review: string
  attendee: {
    id: string
    name: string
    avatar?: string
  }
  created: string
  approved: boolean
  event: {
    id: string
    title: string
  }
}

const Evaluation: FunctionComponent<EvaluationProps> = ({
  id,
  rating,
  review,
  event,
  created,
  approved,
  attendee,
}) => {
  const title = event.title.length > 22 ? `${event.title.substr(0, 22)}...` : event.title;


  const [approveEvaluation, {loading}] = useMutation(mutation);

  const onOpenEvaluation = () => {
    window.location.assign(reverse('attendees_detail_evaluation', {id: attendee.id}) + '?ref=dashboard');
  };

  const onApprove = React.useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    approveEvaluation({variables: {id}}).then(
      () => {
        showInfo('Evaluation was approved');
      },
      (apolloError) => {
        apolloError.graphQLErrors.map((error: GraphQLError) => showError(error.message));
      },
    );
  }, [approveEvaluation, id]);

  return (
    <div className="grid grid-cols-5 gap-x-2 pt-3 gap-y-1 text-base pb-6 px-5 hover:bg-blue-table-hover
     hover:cursor-pointer" onClick={onOpenEvaluation}>
      <div className="col-span-3 flex">
        <Avatar className="h-9 w-9" url={attendee.avatar} name={attendee.name}/>
        <div className="pl-2 flex flex-col">
          <div>{attendee.name}</div>
          <div className="text-gray-dark text-xs">{title}</div>
        </div>
      </div>
      <div className="col-span-2 text-right">
        <Rating rating={rating} approved={approved}/><br/>
        <span className="text-sm text-gray-dark">{created}</span>
      </div>
      <div className="col-span-5">{review}</div>
      {!approved &&
      <div className="col-span-5">
        <PrimaryButton short={true} className="mr-3"
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => onApprove(e)}
          disabled={loading}>{loading && <IconRingSpinner/>} Approve</PrimaryButton>
      </div>
      }
    </div>
  );
};


const mutation = gql`
  mutation ApproveEvaluation($id: ID!) {
    approveEvaluation(evaluationId: $id) {
      id
      approved
    }
  }
`;

export default Evaluation;
